/**
 * Application-wide constants
 * Keep in sync with backend/src/config/constants.js
 */

export const MENU_CATEGORIES = ['HOT', 'COLD', 'MISC'];

export const EMPTY_MENU = Object.fromEntries(MENU_CATEGORIES.map(c => [c, []]));

export const CATEGORY_LABELS = {
  HOT: 'HOT (Hot Food)',
  COLD: 'COLD (Cold Items)',
  MISC: 'MISC (Miscellaneous)'
};

export const CATEGORY_STYLES = {
  HOT: { emoji: '🔥', label: 'Hot', color: '#d32f2f' },
  COLD: { emoji: '❄️', label: 'Cold', color: '#1976d2' },
  MISC: { emoji: '📦', label: 'Misc', color: '#7b7b7b' }
};
